import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

import { uniqueToken, Role } from "../../../api/DataApis";
import axios from "axios";
import Select from 'react-select';
import { getCorporateList, addFilterCategory } from "../../../Apis/Setting";


function Add(props) {
  const { pid } = useParams();
  document.title = "Category List | Add";
  let navigate = useNavigate();
  let location = useLocation();
  let FilterCategoryViewData = location?.state?.FilterCategoryViewData;
  const sluggg = FilterCategoryViewData?.slug;
  console.log("sluggggg", sluggg);

  const [TitleName, setTitleName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [FilterCategoryData, setFilterCategoryData] = useState([]);
  const [Description, setDescription] =  useState("");
  const [loading, setLoading] = useState(false);
  const [CorporateData, setCorporateData] = useState([]);
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [loadings, setLoadings] = useState(false);

    const handleDescriptionChange =  (e) =>  setDescription(e.target.value);
  const handlecorporateChange = (selectedOption) => {
    console.log("selectedOption3wrewgfreh", selectedOption);
    if(selectedOption) {
      setSelectedCorporate( { id : selectedOption._id } );
       } 
         else {
           setSelectedCorporate(null); // Reset state when cleared
         }
  }

            const fetchCorporate = async () => {
             try {
               const corporatesData = await getCorporateList();
               console.log("corporateData", corporatesData);
               setCorporateData(corporatesData?.data || []);
             } catch (error) {
               console.error("Error fetching classes:", error);
             }
           };
           useEffect(() => {
             if (Role === "false") {
               fetchCorporate();  // Only fetch corporate data if Role === "false"
             }
           }, [Role]);



  const handleTitleName = (e) => {
    setTitleName(e.target.value);
  };

  const corporateOptions = CorporateData?.map(corporate => ({
    value: corporate._id,
    label: `${corporate.corporate_name} (${corporate?.email})`,
    _id: corporate._id,
  }));



  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  // Handle additional input value

  const AddFilterCategory = async () => {
    let formData = new FormData();
    formData.append("title", TitleName);
  
    if (!selectedCorporate && Role === "false") {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select a Corporate before proceeding.",
      });
      return;
    }
  
    if (selectedFile) {
      formData.append("master_image", selectedFile);
    }
  
    if (Description) {
      formData.append("description", Description);
    }
  
    setLoading(true);
    Swal.fire({
      title: "Adding Category...",
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    try {
      let response = await addFilterCategory(formData);
  
      if (response?.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Category Added Successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/masters/categorylist`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.message || "Failed to add Filter Category",
        });
      }
    } catch (error) {
      console.error("Error in AddFilterCategory:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      {FilterCategoryViewData?.title ? (
                        <>Category Add - ({FilterCategoryViewData.title})</>
                      ) : (
                        <>Category Add</>
                      )}
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr style={{ marginTop: "-5px" }} />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Title
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleTitleName}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        {Role ==="false" && (
                          <>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="file"
                              className="col-sm-2 control-label"
                            >
                              Select Corporate
                            </label>
                            <div className="col-sm-6">
                            <Select
                              options={corporateOptions}
                              onChange={handlecorporateChange}
                              value={selectedCorporate ? corporateOptions?.find(option => option.value === selectedCorporate.id) : null}
                              placeholder="Select Corporate"
                              isClearable
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  height: '38px', 
                                  width: '100%',
                                  boxShadow: 'none',
                                  minWidth: '0',
                                  flex: 1,
                                }),
                              }}
                            />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        </>
                        )}
                          <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Description
                            </label>
                            <div className="col-sm-6">
                              <textarea
                              type="text"
                                onChange={handleDescriptionChange}
                                className="form-control"
                                id=""
                                name=""
                                value={Description}
                                autoComplete="off"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="file"
                              className="col-sm-2 control-label"
                            >
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="file"
                                onChange={handleFileChange}
                                className="form-control"
                                id="file"
                                name="file"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                    <div className="form-group">
                          <div className="row">
                            <div className="col-sm-6">
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={AddFilterCategory}
                              >
                                Add Filter Category
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
